import React from 'react'
import {ConceptoItemDetalle} from './ConceptoItemDetalle'

function ConceptoItem(props) {
  const displayItems = (props) => {
    const conceptos = props.conceptos

    console.log(props)

    let fullUrl = ''

    let conceptoRefs = []

    const previewImage = (index, idElementoNum) => {
      const [file] = conceptoRefs[index].querySelector('#file-concepto-' + idElementoNum).files
      if (file) {
        document
          .getElementsByClassName('home-concepto-' + idElementoNum)[0]
          .setAttribute('src', URL.createObjectURL(file))
        document.getElementById('ribbon-concepto-' + idElementoNum).classList.remove('d-none')
      }
    }

    const handleChange = (event) => {
      this.setState({
        selectedFile: event.target.files,
        responseArray: [],
      })
    }

    if (props) {
      if (conceptos) {
        if (conceptos.length > 0) {
          return conceptos.map((concepto, index) => {
            let idElementoNum = concepto.idElement.split('-')[2]
            fullUrl = concepto.fullUrl

            return (
              <ConceptoItemDetalle
                key={index}
                concepto={concepto}
                deleteConcept={props.deleteConcept}
              />
            )
          })
        } else {
          return <h3>No hay conceptos</h3>
        }
      } else {
        return <h3>No hay conceptos</h3>
      }
    } else {
      return <h3>No hay conceptos</h3>
    }
  }
  return <>{displayItems(props)}</>
}

export {ConceptoItem}
